import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/authContext"
import { getUserStatus } from "../services/UserServices"
import "../assets/styles/NotApproved.css"

const NotApproved = () => {
  const [checkingStatus, setCheckingStatus] = useState(false)
  const navigate = useNavigate()
  const { getToken } = useAuth()

  // Verificar estado del usuario cada 30 segundos
  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        setCheckingStatus(true)
        const token = await getToken()
        if (!token) {
          console.error("No se encontró token de autenticación")
          return
        }

        const status = await getUserStatus(token)
        
        // Si el usuario está aprobado, redirigir a la página principal
        if (status) {
          navigate("/")
        }
      } catch (error) {
        console.error("Error checking user status:", error)
      } finally {
        setCheckingStatus(false)
      }
    }

    // Verificar inmediatamente al cargar la página
    checkUserStatus()

    // Configurar verificación periódica cada 30 segundos
    const interval = setInterval(checkUserStatus, 30000)

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(interval)
  }, [navigate, getToken])

  return (
    <div className="not-approved-container">
      <h1 className="not-approved-title">Cuenta No Aprobada</h1>
      <p className="not-approved-message">
        Tu cuenta está pendiente de aprobación. Por favor, contacta con soporte para más información.
        {checkingStatus && (
          <span style={{ display: 'block', marginTop: '10px', fontSize: '14px', color: '#666' }}>
            Verificando estado de aprobación...
          </span>
        )}
      </p>
      <div className="not-approved-buttons">
        <Link to="/" className="button primary-button">
          Volver al Inicio
        </Link>
        <Link to="/contact" className="button secondary-button">
          Contactar Soporte
        </Link>
      </div>
    </div>
  )
}

export default NotApproved

